import { FC, memo } from 'react'
import { Box, BoxProps, ScaleFade } from '@chakra-ui/react'

const CalendarCard: FC<BoxProps> = ({ children, ...rest }) => {
  return (
    <ScaleFade in={true}>
      <Box p={2} width={{ base: '100%', md: '300px' }} maxWidth={{ base: '100%', md: '300px' }} rounded="sm" {...rest}>
        {children}
      </Box>
    </ScaleFade>
  )
}

export default memo(CalendarCard)
